import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Link, useSearchParams } from 'react-router-dom';
import {
    deleteMAFAA030,
    getAdminLoginUser,
    postMAFAA030Comments,
    postMAFAA030VisitedCount,
    postMAFAA040,
    putMAFAA030,
    putMAFAA030Limit,
    putMAFAA030updatePosition,
} from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { DOMAIN_USER, getStatusText, MENU_ADVERTISES, MESSAGE, selectStatusColor } from '../../../shared/constants/app';
import { formatDate, handleFocus } from '../../../utils';

const MAFAA040 = () => {
    const dateLimitRef = useRef();
    const startDateRef = useRef();
    const endDateRef = useRef();
    const startDateBannerRef = useRef();
    const endDateBannerRef = useRef();
    const recruitFromBannerRef = useRef();
    const recruitEndBannerRef = useRef();
    const [dataStatistics, setDataStatistics] = useState([]);
    const [dataBanners, setDataBanners] = useState([]);
    const [dataComments, setDataComments] = useState([]);
    const [searchCondition, setSearchCondition] = useState('MemberID');
    const [keyword, setKeyword] = useState('');
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [filterPopup, setFilterPopup] = useState(false);
    const currentDate = moment().format('YYYY-MM-DD');
    const [payloadLimit, setPayloadLimit] = useState({
        changeCount: 0,
        changeDate: null,
    });

    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [selectedDates, setSelectedDates] = useState({});
    const [orders, setOrders] = useState([]);
    const [isEnds, setIsEnds] = useState({});
    const [dataSave, setDataSave] = useState({
        bannerSeq: null,
        recruitSeq: null,
        goodCode: '',
        startDate: '',
        endDate: '',
        recruitFrom: '',
        recruitEnd: '',
        isEnd: 'N',
        comment: '',
        order: null,
    });

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };
    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name, memberId = '') => {
        setDateRate('');
        if (
            name === 'startDateBanner' ||
            name === 'endDateBanner' ||
            name === 'recruitFromBanner' ||
            name === 'recruitEndBanner'
        ) {
            setSelectedDates((prev) => ({
                ...prev,
                [memberId]: {
                    ...prev[memberId],
                    [name]: date,
                },
            }));
            setDataSave((prev) => ({ ...prev, [name]: moment(date).format('YYYY-MM-DD') }));
        } else if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleChange = (e, memberId = '', index) => {
        const { name, value } = e.target;
        if (name === 'order') {
            const dataValue = value > 0 ? parseInt(value, 10) : value;
            setOrders((prev) => {
                const newOrders = [...prev];
                newOrders[index] = dataValue;
                return newOrders;
            });
        }
        if (name === 'isEnd') {
            setIsEnds((prev) => ({
                ...prev,
                [memberId]: {
                    ...prev[memberId],
                    [name]: value,
                },
            }));
        }

        setDataSave((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = ({ bannerSeq, recruitSeq, goodCode }) => {
        const bannerData = dataBanners.find((banner) => banner.seq === bannerSeq) || {};

        const payload = {
            bannerSeq: bannerSeq,
            recruitSeq: recruitSeq,
            goodCode: goodCode,
            startDate: dataSave.startDateBanner || bannerData.startDate,
            endDate: dataSave.endDateBanner || bannerData.endDate,
            recruitFrom: dataSave.recruitFromBanner || bannerData.recruitFrom,
            recruitEnd: dataSave.recruitEndBanner || bannerData.recruitEnd,
            isEnd: dataSave.isEnd || bannerData.isEnd,
            comment: dataSave.comment || bannerData.comment,
            order: dataSave.order || bannerData.ordSeq,
        };

        if (payload.startDate > payload.endDate) {
            alert('배너 종료일이 배너 시작일 이전입니다.배너 시작일을 확인하세요.');
            handleFocus('startDateBanner');
            return;
        } else if (payload.recruitFrom > payload.recruitEnd) {
            alert('채용 종료일이 채용 시작일 이전입니다.채용 시작일을 확인하세요.');
            handleFocus('recruitFromBanner');
            return;
        } else if (payload.startDate < payload.recruitFrom) {
            alert('배너 시작일이 채용시작일 이전입니다.배너 시작일을 확인하세요.');
            handleFocus('startDateBanner');
            return;
        } else if (payload.endDate > payload.recruitEnd) {
            alert('배너 종료일이 채용 종료일 이후입니다.채용 종료일을 확인하세요.');
            handleFocus('endDateBanner');
            return;
        } else if (!payload.comment || payload.comment === '') {
            window.alert('코멘트를 입력해 주세요.');
            handleFocus('comment');
            return;
        }

        const isConfirm = window.confirm(MESSAGE.confirm.update);

        if (isConfirm) {
            putMAFAA030(payload)
                .then(() => {
                    window.alert(MESSAGE.notify.updateSuccess);
                    getListData();
                    setDataSave((prev) => ({
                        ...prev,
                        comment: '',
                    }));
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.updateError);
                });
        }
    };

    const handleDelete = (id) => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAFAA030(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    const getListData = async (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        try {
            const { data } = await postMAFAA040({
                page: currentPage,
                searchCondition,
                keyword: keyword?.trim(),
                size: dataSave?.size || 40,
                startDate: startDateFormated,
                endDate: endDateFormated,
            });

            let banners = data.data.banners || [];
            setDataStatistics(data.data.statistics[0]);

            // 2. get visited count
            if (banners.length > 0) {
                const bannerSeqList = banners.map((b) => b.seq);
                const response = await postMAFAA030VisitedCount(bannerSeqList);
                const visitedResp = response.data;

                // merge to banner
                banners = banners.map((b) => {
                    const visitedArr = visitedResp[b.seq];
                    const visitedData = visitedArr && visitedArr.length > 0 ? visitedArr[0] : {};
                    return {
                        ...b,
                        visitedFromBanner: visitedData.visitedFromBanner ?? b.visitedFromBanner,
                        visitedFromListRecruit: visitedData.visitedFromListRecruit ?? b.visitedFromListRecruit,
                    };
                });
            }

            setDataBanners(data.data.banners);
            const memberIds = [...new Set(data.data.banners.map((banner) => banner.memberId))];

            const commentsResponse = await postMAFAA030Comments(memberIds);
            const comments = {};
            if (commentsResponse?.data) {
                memberIds.forEach((memberId) => {
                    if (commentsResponse.data[memberId]) {
                        comments[memberId] = commentsResponse.data[memberId];
                    }
                });
            }
            const orderSequences = data.data.banners.map((banner) => banner.ordSeq);
            setOrders(orderSequences);
            setDataComments(comments);
            setPages(data.info);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdatePosition = async () => {
        if (!dataBanners || !Array.isArray(dataBanners) || dataBanners.length === 0) {
            return;
        }

        const seqListPayload = dataBanners.map((item) => item.seq);

        const payload = {
            seqList: seqListPayload,
            adPositionList: orders,
        };

        try {
            await putMAFAA030updatePosition(payload);
            window.alert('순서가 변경되었습니다.');
            getListData();
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeDateLimit = (date) => {
        setPayloadLimit((prev) => ({
            ...prev,
            changeDate: moment(date).format('YYYY-MM-DD'),
        }));
    };

    const handleChangeLimit = (e) => {
        const { name, value } = e.target;
        const dataValue = value > 0 ? parseInt(value, 10) : value;
        setPayloadLimit((prev) => ({
            ...prev,
            [name]: dataValue,
        }));
    };

    const handleLimit = () => {
        if (payloadLimit.changeCount <= 0 || payloadLimit.changeCount === dataStatistics.bannerLimit.toString()) {
            alert('그랜드배너 개수 입력해 주세요.');
            return;
        }
        payloadLimit.typeBanner = 'GRANDBANNER';

        putMAFAA030Limit(payloadLimit)
            .then(() => {
                alert('변경되었습니다.');
                getListData();
            })
            .catch((error) => console.log(error));
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('MemberID');
        setKeyword('');
        setDateRate('');
        setStartDate('');
        setEndDate('');
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    const handleShowComment = (memberId) => {
        setDataSave({});
        setSelectedMemberId(selectedMemberId === memberId ? null : memberId);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchParams({ page: 1 });
            getListData(1);
        }
    };

    const handleOpenUser = async (e, memberID) => {
        e.preventDefault();
        const adminResponse = await getAdminLoginUser({ params: { memberID } });
        const url = DOMAIN_USER + '/auth-redirect?token=' + adminResponse.data;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_ADVERTISES} />
                <div className="content-right business-banner">
                    <div className="title">그랜드 배너</div>
                    <div className="group-filer-right">
                        <div className="group-filer-right-title">
                            그랜드 배너 Display <input value={dataStatistics.bannerLimit} readOnly />
                            개수:
                        </div>
                        <button className="group-filer-right-button" onClick={() => setFilterPopup(true)}>
                            개수 변경
                        </button>
                    </div>
                    {filterPopup && (
                        <div className="group-filer-right-popup">
                            <div className="popup-title">그랜드 배너 Display 개수 변경</div>
                            <ul>
                                <li>
                                    <div className="label-input">현재 Display 개수</div>
                                    <input type="number" readOnly value={dataStatistics.bannerLimit} />
                                </li>
                                <li>
                                    <div className="label-input">변경 Display 개수</div>
                                    <input
                                        type="text"
                                        value={payloadLimit.changeCount}
                                        name="changeCount"
                                        onChange={handleChangeLimit}
                                    />
                                    <div className="note-input">※(4배수-2) 개수로 입력하세요.</div>
                                </li>
                                <li>
                                    <div className="label-input">변경 일자</div>
                                    <div className="datepicker-child">
                                        <DatePicker
                                            ref={dateLimitRef}
                                            locale={'ko'}
                                            placeholderText={'YYYY/MM/DD'}
                                            dateFormat={'yyyy/MM/dd'}
                                            selected={payloadLimit.changeDate}
                                            name="changeDate"
                                            onChange={(date) => handleChangeDateLimit(date)}
                                            minDate={moment().add(1, 'days').toDate()}
                                        />
                                        <i
                                            className="icon icon-date"
                                            id="date-litmit-icon"
                                            onClick={() => dateLimitRef.current.setFocus()}
                                        />
                                    </div>
                                </li>
                                <div className="group-filer-right-popup-button">
                                    <button onClick={handleLimit}>변경</button>
                                    <button onClick={() => setFilterPopup(false)}>취소</button>
                                </div>
                            </ul>
                        </div>
                    )}
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>조건 검색</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="MemberID">회원 ID</option>
                                                <option value="Title">채용공고 제목</option>
                                                <option value="BizCompany">치과명</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="input-table"
                                                placeholder="검색어 입력"
                                                value={keyword}
                                                onChange={inputChange}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>검색어 입력</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>
                    <div className="results">
                        <div className="group-table-results">
                            <div className="table-left">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{dataStatistics.bannerRegisteredToday}</td>
                                            <td>{dataStatistics.bannerRunningToday}</td>
                                            <td>{dataStatistics.bannerExpiringToday}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-right">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th>등록미확인</th>
                                            <th>등록확인</th>
                                            <th>게재중</th>
                                            <th>게재예정</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{dataStatistics.bannerApproved}</td>
                                            <td>{dataStatistics.bannerPendingOrRejected}</td>
                                            <td>{dataStatistics.bannerCurrentlyActive}</td>
                                            <td>{dataStatistics.bannerScheduled}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="table-details">
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th style={{ width: '3%' }}></th>
                                        <th style={{ width: '8%' }}>
                                            회원ID
                                            <br />
                                            (이름)
                                        </th>
                                        <th style={{ width: '5%' }}>치과명</th>
                                        <th style={{ width: '60px' }}>
                                            우선 순위
                                            <br />
                                            <button
                                                className="btn btn-gray-bold"
                                                style={{
                                                    width: 'max-content',
                                                    height: 'max-content',
                                                    padding: '0 5px',
                                                    fontSize: '14px',
                                                }}
                                                onClick={handleUpdatePosition}
                                            >
                                                변경
                                            </button>
                                        </th>
                                        <th style={{ width: '60px' }}>배너상태</th>
                                        <th>
                                            채용공고
                                            <br />
                                            조회수
                                        </th>
                                        <th style={{ width: '6%' }}>신청일</th>
                                        <th style={{ width: '6%' }}>결제일</th>
                                        <th style={{ width: '12%' }}>광고상품</th>
                                        <th style={{ width: '15%' }}>
                                            서비스기간
                                            <br />
                                            (채용기간)
                                        </th>
                                        <th style={{ width: '60px' }}>남은일수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataBanners && dataBanners?.length > 0 ? (
                                        dataBanners.map((item, index) => {
                                            return (
                                                <React.Fragment key={'banner' + index}>
                                                    <tr>
                                                        <td>{item.seq}</td>
                                                        <td className="dataBanners_nameKor">
                                                            <button
                                                                onClick={() => handleShowComment(item?.seq)}
                                                                className="dataBanners_nameKor"
                                                            >
                                                                {item.memberId}
                                                                <br />({item.nameKor})
                                                            </button>
                                                            <Link
                                                                onClick={(e) => handleOpenUser(e, item?.memberId)}
                                                                style={{ paddingRight: '15px' }}
                                                            >
                                                                덴탈잡로그인
                                                            </Link>
                                                            <div>
                                                                <i
                                                                    onClick={() => handleShowComment(item?.seq)}
                                                                    className={`icon icon-arrow-right icon-arrow-style ${selectedMemberId === item?.seq
                                                                        ? 'blue active'
                                                                        : ''
                                                                        }`}
                                                                ></i>
                                                            </div>
                                                        </td>
                                                        <td>{item.bizCompany}</td>
                                                        <td>
                                                            {item.statusFlag === 'O' &&
                                                                item.isEnd === 'N' &&
                                                                moment(item.recruitEnd).format('YYYY-MM-DD') >=
                                                                currentDate &&
                                                                moment(item.startDate).isSameOrBefore(currentDate) &&
                                                                moment(item.endDate).isSameOrAfter(currentDate) && (
                                                                    <input
                                                                        className="button-table"
                                                                        value={
                                                                            orders[index] !== undefined
                                                                                ? orders[index]
                                                                                : item.ordSeq
                                                                        }
                                                                        name="order"
                                                                        style={{ width: '50px', textAlign: 'center' }}
                                                                        onChange={(e) =>
                                                                            handleChange(e, item.memberId, index)
                                                                        }
                                                                    />
                                                                )}
                                                        </td>
                                                        <td>
                                                            <span
                                                                style={{
                                                                    background: selectStatusColor(
                                                                        item.statusFlag,
                                                                        item.recruitEnd,
                                                                        item.startDate,
                                                                        item.endDate,
                                                                        item.isEnd,
                                                                    ),
                                                                    color: '#fff',
                                                                    padding: '3px 10px',
                                                                    borderRadius: '16px',
                                                                    whiteSpace: 'nowrap',
                                                                }}
                                                            >
                                                                {getStatusText(
                                                                    item.statusFlag,
                                                                    item.recruitEnd,
                                                                    item.startDate,
                                                                    item.endDate,
                                                                    item.isEnd,
                                                                )}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {item.title}
                                                            <br />
                                                            (채용광고 조회: {item.visitedFromListRecruit || 0} /
                                                            배너광고 조회: {item.visitedFromBanner || 0})
                                                        </td>
                                                        <td>
                                                            {moment(item.addDate).format('YYYY.MM.DD')} <br />{' '}
                                                            {moment(item.addDate).format('a hh:mm:ss')}
                                                        </td>
                                                        <td>
                                                            {moment(item.ipGumCheckDate).format('YYYY.MM.DD')} <br />{' '}
                                                            {moment(item.ipGumCheckDate).format('a hh:mm:ss')}
                                                        </td>
                                                        <td>{item.goodName}</td>
                                                        <td>
                                                            {formatDate(item.startDate)} ~ {formatDate(item.endDate)}
                                                            <br />({formatDate(item.recruitFrom)} ~{' '}
                                                            {formatDate(item.recruitEnd)})
                                                        </td>
                                                        <td>
                                                            {moment(item.endDate).isBefore(moment(), 'day') ? (
                                                                '' // endDate < currentDate
                                                            ) : moment(item.endDate).isSame(moment(), 'day') ? (
                                                                <span style={{ color: '#FF0000' }}>Today</span> // endDate = currentDate
                                                            ) : (
                                                                (() => {
                                                                    const daysDiff = moment(item.endDate).diff(
                                                                        moment(),
                                                                        'days',
                                                                    ); // tính khoảng cách ngày
                                                                    return daysDiff <= 3 ? (
                                                                        <span style={{ color: '#FF0000' }}>
                                                                            ({daysDiff + 1})
                                                                        </span> // nếu khoảng cách <= 3 ngày, in màu đỏ
                                                                    ) : (
                                                                        <span style={{ color: '#0000FF' }}>
                                                                            ({daysDiff + 1})
                                                                        </span> // nếu khoảng cách > 3 ngày, in màu xanh
                                                                    );
                                                                })()
                                                            )}
                                                        </td>
                                                    </tr>
                                                    {selectedMemberId === item?.seq && (
                                                        <tr className="show-comment">
                                                            <td colSpan={11}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>상품명</td>
                                                                            <td>배너시작일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={startDateBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'startDateBanner',
                                                                                                item.memberId,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberId]
                                                                                                ?.startDateBanner ||
                                                                                            item.startDate
                                                                                        }
                                                                                        id="startDateBanner"
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="start-date-icon"
                                                                                        onClick={() =>
                                                                                            startDateBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>채용시작일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={recruitFromBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'recruitFromBanner',
                                                                                                item.memberId,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberId]
                                                                                                ?.recruitFromBanner ||
                                                                                            item.recruitFrom
                                                                                        }
                                                                                        id="recruitFromBanner"
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="recruit-from-date-icon"
                                                                                        onClick={() =>
                                                                                            recruitFromBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>배너상태</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>덴탈잡그랜드배너(채용광고포함)</td>
                                                                            <td>배너종료일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={endDateBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'endDateBanner',
                                                                                                item.memberId,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberId]
                                                                                                ?.endDateBanner ||
                                                                                            item.endDate
                                                                                        }
                                                                                        id="endDateBanner"
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="end-date-icon"
                                                                                        onClick={() =>
                                                                                            endDateBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>채용종료일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={recruitEndBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'recruitEndBanner',
                                                                                                item.memberId,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberId]
                                                                                                ?.recruitEndBanner ||
                                                                                            item.recruitEnd
                                                                                        }
                                                                                        id="recruitEndBanner"
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="recuit-end-date-icon"
                                                                                        onClick={() =>
                                                                                            recruitEndBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="select-box">
                                                                                    <select
                                                                                        value={
                                                                                            isEnds[item.memberId]
                                                                                                ?.isEnd !== undefined
                                                                                                ? isEnds[item.memberId]
                                                                                                    ?.isEnd
                                                                                                : item.isEnd
                                                                                        }
                                                                                        onChange={(e) =>
                                                                                            handleChange(
                                                                                                e,
                                                                                                item.memberId,
                                                                                            )
                                                                                        }
                                                                                        name="isEnd"
                                                                                    >
                                                                                        <option value="N">등록</option>
                                                                                        <option value="Y">마감</option>
                                                                                    </select>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Comment</td>
                                                                            <td colSpan={5}>
                                                                                <textarea
                                                                                    name="comment"
                                                                                    value={dataSave.comment || ''}
                                                                                    onChange={handleChange}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className="note-table">
                                                                    *Comment 등록형식: [상품명] / [Comment] ex
                                                                    프리미엄배너/전화가 안와요 불만
                                                                    <br />
                                                                    *반드시 배너 종료일이 채용 종료일보다 작거나 같도록
                                                                    확인하고 설정해 주세요.
                                                                    <div className="d-flex gap-2 justify-content-center mt-2">
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={() =>
                                                                                handleSave({
                                                                                    bannerSeq: item.seq,
                                                                                    recruitSeq: item.recruitSeq,
                                                                                    goodCode: item.goodCodeName,
                                                                                })
                                                                            }
                                                                        >
                                                                            등록 / 수정
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger"
                                                                            onClick={() => handleDelete(item.seq)}
                                                                        >
                                                                            삭제
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="table-comment-results"
                                                                    style={{ overflow: 'scroll', maxHeight: '400px' }}
                                                                >
                                                                    <div className="table-comment-results-title">
                                                                        등록된 Comment (
                                                                        {dataComments[item.memberId]?.length})
                                                                    </div>
                                                                    <table className="table-gray table-comments">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Seq</th>
                                                                                <th>등록일</th>
                                                                                <th>관리자명</th>
                                                                                <th>사이트</th>
                                                                                <th>Comment</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {dataComments[item.memberId] &&
                                                                                dataComments[item.memberId]?.length > 0 ? (
                                                                                dataComments[item.memberId].map(
                                                                                    (comment, index) => (
                                                                                        <tr
                                                                                            key={
                                                                                                'comments' +
                                                                                                item.memberId +
                                                                                                index
                                                                                            }
                                                                                        >
                                                                                            <td>{comment.seq}</td>
                                                                                            <td>
                                                                                                {formatDate(
                                                                                                    comment.addDate,
                                                                                                )}
                                                                                            </td>
                                                                                            <td>{comment.adminName}</td>
                                                                                            <td>{comment.sitePost}</td>
                                                                                            <td>{comment.comments}</td>
                                                                                        </tr>
                                                                                    ),
                                                                                )
                                                                            ) : (
                                                                                <tr key={'no-data-' + item.memberId}>
                                                                                    <td colSpan={5}>
                                                                                        <span className="no-data">
                                                                                            데이타가 없습니다.
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={11}>데이타가 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAFAA040;
